/**
 * Read-only display of proposal processor information.
 * Shows who created/modified the record and when.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import useUserName from '../../../hooks/useUserName';
var sectionStyle = {
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    padding: '16px',
    marginTop: '16px',
    backgroundColor: '#f9fafb',
};
var titleStyle = {
    fontSize: '14px',
    fontWeight: 600,
    color: '#475569',
    marginBottom: '12px',
};
var rowStyle = {
    display: 'flex',
    gap: '8px',
    marginBottom: '6px',
    fontSize: '13px',
};
var labelCss = {
    fontWeight: 500,
    color: '#666',
    width: '180px',
    flexShrink: 0,
};
var ProcessorInfo = function (_a) {
    var createdBy = _a.createdBy, createdAt = _a.createdAt, updatedBy = _a.updatedBy, updatedAt = _a.updatedAt;
    var intl = useIntl();
    var creatorName = useUserName(createdBy !== null && createdBy !== void 0 ? createdBy : null).name;
    var updaterName = useUserName(updatedBy !== null && updatedBy !== void 0 ? updatedBy : null).name;
    if (!createdBy && !updatedBy)
        return null;
    var formatDateTime = function (value) {
        if (!value)
            return '\u2014';
        var date = intl.formatDate(value, { day: '2-digit', month: '2-digit', year: 'numeric' });
        var time = intl.formatTime(value, { hour: '2-digit', minute: '2-digit' });
        return "".concat(date, " ").concat(time);
    };
    return (React.createElement("div", { style: sectionStyle },
        React.createElement("div", { style: titleStyle }, intl.formatMessage({ id: 'ui-czna-authorities.processorInfo.title' })),
        createdBy && (React.createElement("div", { style: rowStyle },
            React.createElement("span", { style: labelCss }, intl.formatMessage({ id: 'ui-czna-authorities.processorInfo.createdBy' })),
            React.createElement("span", { style: { color: '#333' } }, creatorName || createdBy),
            React.createElement("span", { style: { color: '#999', marginLeft: '8px' } }, formatDateTime(createdAt)))),
        updatedAt && updatedAt !== createdAt && (React.createElement("div", { style: rowStyle },
            React.createElement("span", { style: labelCss }, intl.formatMessage({
                id: updatedBy && updatedBy !== createdBy
                    ? 'ui-czna-authorities.processorInfo.updatedBy'
                    : 'ui-czna-authorities.processorInfo.lastModified',
            })),
            updatedBy && updatedBy !== createdBy && (React.createElement("span", { style: { color: '#333' } }, updaterName || updatedBy)),
            React.createElement("span", { style: { color: '#999', marginLeft: '8px' } }, formatDateTime(updatedAt))))));
};
export default ProcessorInfo;
